import React, { useState, useRef } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@material-ui/core";
// styles
import "../../components/utils/form/form.css";
// utils
import FormButton from "../../components/utils/button/FormButton";
// functions
import { update } from "./ConciliacionesFunctions";
import CommonForm from "../../components/utils/form/CommonForm";
// recoil
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { userCredentials, formIsOpen, snackbarData, formData } from '../../recoilState/GlobalState'
import { handleResponse } from "../../services/Local-services";

export default function ComentarioModal(props) {
    const [comentario, setComentario] = useState('');
    const [archivo, setArchivo] = useState('');
    const [nombreArchivo, setNombreArchivo] = useState('');
    const [tipoDeArchivo, setTipoDeArchivo] = useState('C');
    const [inRequest, setInRequest] = useState(false);

    const setIsOpen = useSetRecoilState(formIsOpen);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const data = useRecoilValue(formData);

    const { selected, setSelected, procede, updateList } = props.props;

    async function handleAction(e) {
        e.preventDefault();
        const functions = { setSnackbarInfo, setInRequest, setIsOpen, setSelected, updateList };
        setInRequest(true)
        const response = await update(credentials, selected, procede, archivo, comentario, tipoDeArchivo);
        return handleResponse(response, 'Operacion exitosa', functions, true)
    };

    const inputFile = useRef(null);
    const onButtonClick = () => inputFile.current.click();

    const handleReaderLoaded = (readerEvt) => {
        const fileContent = readerEvt.currentTarget.result.split(/\r?\n|\r/).join('-!?-');
        setArchivo(fileContent)
    };

    const handleFile = (e) => {
        let file = e.target.files[0];
        if (file) {
            setNombreArchivo(file.name)
            const reader = new FileReader();
            reader.onload = handleReaderLoaded;
            reader.readAsText(file)
        }
    };

    return (
        <CommonForm
            onSubmit={() => { }}
            title={procede === 'archivo' ? 'Importar archivo' : 'Añadir observacion'}
        >
            {procede === 'archivo' ?
                <>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Tipo de archivo</FormLabel>
                        <RadioGroup
                            row
                            value={tipoDeArchivo}
                            onChange={(e) => setTipoDeArchivo(e.target.value)}
                        >
                            <FormControlLabel value="C" label="Conciliacion" control={<Radio />} />
                            <FormControlLabel value="M" label="Movimiento" control={<Radio />} />
                        </RadioGroup>
                    </FormControl>
                    <input
                        style={{ display: "none" }}
                        accept=".csv"
                        ref={inputFile}
                        type="file"
                        onChange={handleFile}
                    />
                    <button type="button" className="add-file-button" onClick={() => onButtonClick()}>
                        Busca en el explorador
                    </button>
                    <p>{nombreArchivo}</p>
                </>
                :
                <TextField
                    label="Observacion"
                    name="comentario"
                    placeholder="Añadir observacion"
                    fullWidth
                    disabled={procede === 'ocultar' || procede === 'revertir' || procede === 'revisar' ? inRequest : true}
                    multiline
                    type="text"
                    value={comentario}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setComentario(e.target.value)}
                />
            }
            <FormButton
                data={data}
                inRequest={inRequest}
                handleAction={handleAction}
            />
        </CommonForm>
    );
};
